<script setup lang="ts">
    const props = defineProps<{ pages: FormGroupMultistepPageStoryblok[]; activePage: number }>();
</script>

<template>
    <div
        v-for="(page, idx) in props.pages"
        v-show="props.activePage === idx + 1"
        :key="page._uid"
        v-editable
    >
        <StoryblokComponentWrapper
            v-for="element in page.formElements"
            :key="element._uid"
            :blok="element"
        />
    </div>
</template>
